import { useEffect, useRef } from 'react';

const activityEvents = [
  'mousemove',
  'mousedown',
  'mouseup',
  'keydown',
  'keyup',
  'touchstart',
  'touchend',
  'touchmove',
  'scroll',
  'wheel',
  'resize',
  'focus',
];

export function useInactivity() {
  const inactivitySecondsRef = useRef<number>(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const resetTimer = () => {
      inactivitySecondsRef.current = 0;
    };

    activityEvents.forEach(event => window.addEventListener(event, resetTimer));

    intervalRef.current = setInterval(() => {
      inactivitySecondsRef.current += 1;
    }, 1000);

    return () => {
      activityEvents.forEach(event =>
        window.removeEventListener(event, resetTimer),
      );
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return () => inactivitySecondsRef.current;
}
